import { render, staticRenderFns } from "./KusBaseMenuAlt.vue?vue&type=template&id=01406d37"
import script from "./KusBaseMenuAlt.vue?vue&type=script&lang=js"
export * from "./KusBaseMenuAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports